import { AssetManager, __private, Asset, warn, Node } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface AssetManager {
        loadBundleAsync(nameOrUrl: string, options: __private._cocos_core_asset_manager_shared__IBundleOptions | null): Promise<AssetManager.Bundle>;
        loadBundleAsync(nameOrUrl: string): Promise<AssetManager.Bundle>;
        /**
         * @param asset 資源名稱
         * @warning 只能傳入由 loadAsset 產生的資源
         */
        releaseAsset(asset: string): void;
        /**
         * @param asset Prefab 節點實例
         * @warning 只能傳入由是 prefab 產生的節點
         */
        releaseAsset(asset: Node): void;
    }
}

AssetManager.prototype.loadBundleAsync = async function loadBundleAsync(
    this: AssetManager,
    nameOrUrl: string,
    options?:
        | __private._cocos_core_asset_manager_shared__IBundleOptions
        | __private._cocos_core_asset_manager_shared__CompleteCallbackWithData<AssetManager.Bundle>
        | null,
): Promise<AssetManager.Bundle> {
    return new Promise<AssetManager.Bundle>((resolve, reject) => {
        this.loadBundle(nameOrUrl, options, (err: Error, bundle: AssetManager.Bundle) => {
            if (err) {
                reject(err);
            } else {
                resolve(bundle);
            }
        });
    });
};

const originalReleaseAsset = AssetManager.prototype.releaseAsset;
AssetManager.prototype.releaseAsset = function releaseAsset(this: AssetManager, arg1: Asset | string | Node): void {
    if (arg1 instanceof Node) {
        // @ts-ignore - 需要訪問受保護的 _prefab 屬性
        const prefab = arg1?._prefab?.asset;
        if (prefab) {
            originalReleaseAsset(prefab);
        } else {
            warn(`Prefab not found: name=${arg1.name}, uuid=${arg1.uuid}`);
        }
    } else if (typeof arg1 === 'string') {
        const asset = this.assets.find((entry) => entry.name === arg1);
        if (asset) {
            originalReleaseAsset(asset);
        } else {
            warn(`Asset not found: ${arg1}`);
        }
    } else {
        originalReleaseAsset(arg1);
    }
};
